module.exports = __webpack_public_path__ + "img/icon-arrow-right.03365978.svg";